<template>
    <v-row class="py-12 bank-success" align="center" justify="center" no-gutters>
        <v-col class="text-center py-12 mx-0">
            <v-icon class="my-5" color="primary" size="40">mdi-check-circle</v-icon>
            <span class="d-block body-1 text-secondary font-weight-medium">El banco se ha conectado con éxito</span>
            <v-btn class="mt-5" @click="closeModal" outlined>Continuar</v-btn>
        </v-col>

    </v-row>
</template>
<script>
export default {
   methods: {
       closeModal () {
           localStorage.setItem('isBankModalOpen', false)
       }
   }
}
</script>